import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import SubNav from './SubNav';
import { useNavigate } from '../../utils/routing';
import { CREATE_ASSET, EXISTING_ASSETS } from './queries';
import { ButtonContainer } from './elements';
import { useParams } from 'react-router-dom';
import { AssetsContainer } from './elements';
import moment from 'moment';
import AssignToUsers from '../Assets/AssignToUsers';
import AuthContext from '../../contexts/AuthContext';
import elRed from '../../styles/colors';
import {NewAssetDocuments} from '../Attachments/new';

const NewAsset = ({setShowModal, refetch, withNav}) => {
  const { sellerId, clientNumberLabelFull, sellerName } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [selectedSellerUsers, setSelectedSellerUsers] = useState([]);
  const [existingVins, setExistingVins] = useState([]);
  const [showDuplicateVin, setShowDuplicateVin] = useState(false);
  const [linkedAttachments, setLinkedAttachments] = useState([]);
  const [sellerDocuments, setSellerDocuments] = useState([]);
  const navigate = useNavigate();
  const [createAsset] = useMutation(CREATE_ASSET, {
    onCompleted: (response) => {
      if(refetch) {
        setShowModal(false);
        refetch();
      }
      navigate(`/assets/${response.createAsset.asset.id}`)
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['year'] = parseInt(input['year']);
    if(input['linkedAttachments']) {
      input['linkedAttachmentAttributes'] = linkedAttachments;
      delete input['linkedAttachments'];
    }
    input['sellerUserIds'] = selectedSellerUsers;
    if(input['sellerDocuments']) {
      input['sellerDocumentNotes'] = input['sellerDocuments'].map(document => {
        return document.notes || ''
      });
      input['sellerDocuments'] = input['sellerDocuments'].map(document => {
        return document
      })
    }
    createAsset({ variables: input });
    console.log('input', input)
  });

  const { control, watch, handleSubmit, register, setValue, resetField,
    formState: { errors }
  } = useForm({
    defaultValues: {
      sellerId: sellerId,
      year: parseInt(moment().format('YYYY')),
      make: '',
      model: '',
      vin: '',
      clientNumber: '',
      sellerNotes: '',
      sellerDocuments: []
    }
  });

  const { data } = useQuery(EXISTING_ASSETS);

  useEffect(() => {
    if(data) {
      let vins = data.assets.map(asset => asset.vin);
      setExistingVins(vins);
    }
  }, [data])

  const watchVin = watch('vin');

  const checkVin = () => {
    if(existingVins && watchVin) {
      return existingVins.includes(watchVin);
    }
  }

  useEffect(() => {
    if(watchVin) {
      let exists = checkVin();
      if(exists) {
        setShowDuplicateVin(true);
      }else {
        setShowDuplicateVin(false);
      }
    }else {
      setShowDuplicateVin(false);
    }
  }, [watchVin])

  return (
    <View>
      {withNav &&
        <SubNav sellerId={sellerId} sellerName={sellerName} />
      }
      <AssetsContainer>
        {submitting ?
          DataState.Loading :
          <View>
            <Input.YearPicker
              label="Year:"
              name="year"
              control={control}
              errors={errors}
              {...register("year", {
                required: "Required",
              })}
            />
            <Input.Text
              label="Make:"
              name="make"
              control={control}
              errors={errors}
              {...register("make", {
                required: "Required",
              })}
            />
            <Input.Text
              label="Model:"
              name="model"
              control={control}
              errors={errors}
              {...register("model", {
                required: "Required",
              })}
            />
            <Input.Text
              label="VIN:"
              name="vin"
              control={control}
              errors={errors}
            />
            {showDuplicateVin &&
              <View style={{marginTop: '-10px', marginBottom: '10px'}}>
                <Text style={{fontWeight: 'bold', color: elRed}}>
                  Asset already exists within system. If you need this VIN added,
                  please contact Equiplinc Auction Group.
                </Text>
              </View>
            }
            <Input.Text
              label={`${clientNumberLabelFull}:`}
              name="clientNumber"
              control={control}
            />
            <Input.Text
              label="Seller Notes:"
              name="sellerNotes"
              control={control}
              errors={errors}
            />
            <Text
              style={{marginBottom: '-15px', fontSize: '16px'}}>
              Files:
            </Text>
            {/* <br />
              {expense.expenseFiles && expense.expenseFiles.map(file =>
                <View style={{width: 'fit-content'}}>
                  <Link to={file.url} target='_blank'>
                    <Text>
                      {file.filename}
                    </Text>
                  </Link>
                </View>
              )} */}
            <View>
              <NewAssetDocuments
                recordId={null}
                recordType='Asset'
                attachmentType='Seller Document'
                refetch={refetch}
                name='sellerDocuments'
                setValue={setValue}
                existingFiles={[]}
              />
            </View>
            {/* {watchDocuments.length > 0 &&
              <Text style={{fontWeight: 'bold'}}>Added Documents:</Text>
            }
            {watchDocuments?.length > 0 &&
              watchDocuments?.map((file, index) => {
                return (
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginBottom: '20px'
                    }}
                  >
                    <Text
                      style={{marginRight: '20px'}}
                    >
                      {`${file.name} ${!file.id ? '(Not Saved)' : null}`}
                    </Text>
                    <Text
                      style={{marginRight: '10px'}}
                    >
                      File notes:
                    </Text>
                    <input
                      type='text'
                      style={{flex: 1}}
                      onChange={(e) => setFileNotes(index, e.target.value)}
                    />
                  </View>
                )
              })
            } */}
            <View
              style={{maxWidth: '60vw'}}
            >
              <AssignToUsers
                selectedSellerUsers={selectedSellerUsers}
                setSelectedSellerUsers={setSelectedSellerUsers}
              />
            </View>
            <ButtonContainer>
              <ButtonGroup>
                <Button
                  label="Create Asset"
                  onPress={handleSubmit(onSubmit)}
                  disabled={showDuplicateVin}
                  style={showDuplicateVin ?
                    {opacity: 0.5} :
                    {}
                  }
                />
              </ButtonGroup>
            </ButtonContainer>
          </View>
        }
      </AssetsContainer>
    </View>
  )
}

export default NewAsset;
